/** File tree data fetching and helpers. */

import { useMemo } from "react";
import { useChatStore } from "@/stores/useChatStore";
import { buildEnvironmentFilesTree as buildEnvironmentTree } from "@/lib/environment-files";

export type TreeEntry = FileTreeEntry | DirectoryTreeEntry;

export interface FileTreeEntry {
	type: "file";
	name: string;
	path: string;
	fileId: string;
	size: number;
}

export interface DirectoryTreeEntry {
	type: "directory";
	name: string;
	path: string;
	/** 直下のエントリ。null は未取得 (フォルダを開いたときに初めて取得する)。 */
	children: TreeEntry[] | null;
	/** 直下に取得しきれていない続きがあるか (「さらに表示」の対象)。 */
	hasMore: boolean;
}

/**
 * 読み込み済みディレクトリからツリーを組み立てる。並び順はサーバーが返した順
 * (ディレクトリ優先 + 名前順) をそのまま使う。ルート未取得の間は null を返す。
 */
export function useEnvironmentTree(): { tree: TreeEntry[] | null; rootHasMore: boolean } {
	const environmentFileChildren = useChatStore((s) => s.environmentFileChildren);
	const tree = useMemo(
		() => (environmentFileChildren === null ? null : buildEnvironmentTree(environmentFileChildren)),
		[environmentFileChildren],
	);
	return { tree, rootHasMore: environmentFileChildren?.get("")?.hasMore ?? false };
}
